<template>
  <div class="location-search-block__control">
    <!-- Location Search Input Field -->
    <location-search-input
      :placeholdertext="placeholdertext"
      >
  </location-search-input>
  </div>
</template>

<script>
import LocationSearchInput from "./components/LocationSearchInput.vue";

export default {
  components: {
    "location-search-input": LocationSearchInput
  },
  props: {
    placeholdertext: String
  }
};
</script>
